import {
    type BaseVictoryPointData, VictoryPointDataChit, VictoryPointDataCity, VictoryPointDataDefenderOfColonist, VictoryPointDataDevelopmentCard, VictoryPointDataLargestArmy, VictoryPointDataLongestRoad,
    VictoryPointDataMerchant, VictoryPointDataMetropolis, VictoryPointDataProgressCard, VictoryPointDataSettlement, type VictoryPointTypes,
} from '@colonist/game-base-types'

export class VictoryPointDataController {
    static readonly victoryPointDataList: BaseVictoryPointData[] = [
        new VictoryPointDataSettlement(), new VictoryPointDataCity(), new VictoryPointDataDevelopmentCard(),
        new VictoryPointDataLargestArmy(), new VictoryPointDataLongestRoad(),

        new VictoryPointDataChit(),

        new VictoryPointDataMetropolis(), new VictoryPointDataDefenderOfColonist(),
        new VictoryPointDataProgressCard(), new VictoryPointDataMerchant(),
    ]

    private static readonly typeToData = new Map<VictoryPointTypes, BaseVictoryPointData>(this.victoryPointDataList.map((data) => [data.victoryPointType, data]))

    static getVictoryPointByType(victoryPointType: VictoryPointTypes): BaseVictoryPointData | undefined {
        if(typeof victoryPointType == 'string') victoryPointType = parseInt(victoryPointType, 10)
        return this.typeToData.get(victoryPointType)
    }
}
